import { render, staticRenderFns } from "./TableDetailDialog.vue?vue&type=template&id=7c53587d"
import script from "./TableDetailDialog.vue?vue&type=script&lang=js"
export * from "./TableDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports